import { useMemo, useState, useEffect } from 'react';
import { SelectOption } from 'global';
import { keyBy } from 'utils/arrayUtils';
import { useSelector } from 'react-redux';
import { Account } from '@trnsact/trnsact-shared-types';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';

import { OpportunitiesTableColumn } from '../types';
import { getOpportunitiesTableDealerColumns, getOpportunitiesTablePartnerColumns } from '../lib';

export function useOpportunitiesListColumns() {
  const account = useSelector((state: any) => state.account) as Account;
  const vp = useSelector((state: any) => state.vp);
  const allowEnhancedStagesFlow = useSelector<any, boolean>(portalConfigurationsSelectors.allowEnhancedStagesFlow);

  const isTiersResultsHidden = useSelector(portalConfigurationsSelectors.isTiersResultsHidden);
  const allowManualVoCreation = useSelector(portalConfigurationsSelectors.allowManualVoCreation);

  const initialColumns = useMemo(() => {
    return account.accountType === 'Partner'
      ? getOpportunitiesTablePartnerColumns({ allowEnhancedStagesFlow })
      : getOpportunitiesTableDealerColumns({
          allowEnhancedStagesFlow,
          isTiersResultsHidden,
          allowManualVoCreation,
          isMultiLocationManagementEnabled: vp.multiLocationManagement,
        });
  }, [
    account.accountType,
    allowEnhancedStagesFlow,
    isTiersResultsHidden,
    allowManualVoCreation,
    vp.multiLocationManagement,
  ]);

  const [allColumns, setAllColumns] = useState<OpportunitiesTableColumn[]>(initialColumns);

  const handleColumnsVisibilityChange = (options: SelectOption[]) => {
    const visibleColumnsMap = keyBy(options, 'value');
    setAllColumns(prev => prev.map(column => ({ ...column, isHidden: !visibleColumnsMap[column.renderKey] })));
  };

  const initialVisibleColumns = useMemo(() => initialColumns.filter(({ isHidden }) => !isHidden), [initialColumns]);

  useEffect(() => {
    setAllColumns(initialColumns);
  }, [initialColumns]);

  return {
    allColumns,
    initialVisibleColumns,
    handleColumnsVisibilityChange,
    visibleColumns: allColumns.filter(({ isHidden }) => !isHidden),
  };
}
